import React from 'react';

const NoData = ({ message }) => {
	return (
		<div className="w-100">
			<div className="alert alert-secondary text-center" role="alert">
				{message}
			</div>
		</div>
	);
};

export default NoData;
